<!--
 * @Author: cgh
 * @Date: 2022-08-01 10:53:11
 * @LastEditors: zxf
 * @LastEditTime: 2023-08-24 11:01:28
 * @Description: 问题列表管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        问题列表管理
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleDialog({ type:'add'})"
        />
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="问题描述"
                prop="wtms"
              >
                <el-input
                  v-model.trim="filterParams.wtms"
                  class="c-form__input"
                  placeholder="问题描述"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>  <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="安全类别"
                prop="aqlb"
              >
                <el-select
                  v-model="filterParams.aqlb"
                  clearable
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in aqlbType"
                    :key="item.id"
                    :value="item.id"
                    :label="item.text"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="wtlbTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #wtxq="scope"
            >
              <el-link
                type="primary"
                @click="handleDialog({id: scope.row.id,type: 'details'})"
              >
                {{ scope.row.wtxq }}
              </el-link>
            </template>
            <template
              #fxcd="scope"
            >
              {{ scope.row.fxcd === 'h' ?'高':scope.row.fxcd === 'm' ? '中' :'低' }}
            </template>
            <template
              #aqlbMc="scope"
            >
              {{ scope.row.fxzbMc }} {{ scope.row.dxzbMc }}
            </template>
            <template
              #zdhzyh="scope"
            >
              {{ scope.row.zdhzyh === 'Y' ? '是' : '否' }}
            </template>
            <el-table-column
              prop="enabled"
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  v-if="scope.row.tsbz !== 'Y'"
                  btn-text="编辑"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleDialog({id: scope.row.id,type: 'edit'})"
                />
                <k-button
                  v-if="scope.row.tsbz !== 'Y'"
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  plain
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 添加/修改 -->
    <addOrUpdate-dialog
      v-if="showDialogName === 'edit' || showDialogName === 'add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
    <details-dialog
      v-if="showDialogName==='details'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { wtlbManageService } from './wtlb.service.js';
export default {
  name: 'Wtlb',
  components: {
    addOrUpdateDialog: () => import('./addOrUpdateDialog'),
    detailsDialog: () => import('./detailsDialog')
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        wtms: null, // 设备名称
        xmmc: null, // 设备编号
        aqlb: null // 启用状态
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      // filterParamsRules: {
      //   zxsjQZ: [this.$HMValidator.dateRange('开始时间')]
      // },
      /* 表单校验规则 End */

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'wtxq', slotName: 'wtxq', label: '问题描述', align: 'left', minWidth: '250', type: 'text' },
        { key: 'xmMc', label: '项目名称', align: 'left', minWidth: '250', type: 'text' },
        { key: 'aqlbMc', slotName: 'aqlbMc', label: '安全类别', align: 'left', width: '250', type: 'text' },
        { key: 'szwz', label: '具体位置', align: 'left', minWidth: '130', type: 'text' },
        { key: 'wtsl', label: '问题数量', align: 'center', minWidth: '50', type: 'text' },
        { key: 'fxcd', slotName: 'fxcd', label: '风险程度', align: 'left', minWidth: '60', type: 'text' },
        { key: 'zdhzyh', slotName: 'zdhzyh', label: '是否属于重大火灾隐患', align: 'left', width: '80', type: 'text' },
        { key: 'cjsj', label: '创建时间', align: 'center', width: '180', type: 'dateTime' }
      ]
      /* 表格列配置End */

    };
  },
  computed: {
    aqlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_AQLB) {
        return enums.IFF_AQLB;
      }
      return {};
    }

  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      // [this.trueFilterParams.zxsjq, this.trueFilterParams.zxsjz] = this.trueFilterParams.zxsjQZ;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      wtlbManageService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },

    /**
       * @description: 跳转到查看
       * @author: cgh
       */
    handleDialog (_params) {
      this.showDialogName = _params.type;
      this.dialogParams = _params;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此问题列表数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        wtlbManageService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      wtlbManageService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
